import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_3 = { class: "px-0 ml-2" }
const _hoisted_4 = { class: "underline" }
const _hoisted_5 = {
  key: 1,
  class: "px-0 ml-2"
}
const _hoisted_6 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_7 = { class: "px-0 ml-2" }

import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";
import AuthenticationService from "@/services/authentication-service";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const isLoggedIn: ComputedRef<boolean> = computed(
  (): boolean => !!store.state.currentUser
);

const isAdmin: ComputedRef<boolean> = computed(() => {
  const currentUser = store.state.currentUser;
  return currentUser && currentUser.entitlements.includes("Employee");
});

function login() {
  AuthenticationService.authenticate();
}

function logout() {
  AuthenticationService.logout();
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "nav-link px-0 ml-4",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => (_unref(isLoggedIn) ? logout() : login()), ["prevent"])),
        href: "#"
      }, [
        (_unref(isLoggedIn))
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              class: "fa-lg",
              icon: "sign-out-alt",
              title: _ctx.$t('auth.logout')
            }, null, 8, ["title"]))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              class: "fa-lg",
              icon: "sign-in-alt",
              title: _ctx.$t('auth.login')
            }, null, 8, ["title"]))
      ])
    ]),
    (_unref(isLoggedIn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'EmployeeHome' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$store.state.currentUser.firstName) + " " + _toDisplayString(_ctx.$store.state.currentUser.lastName), 1)
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.currentUser.firstName) + " " + _toDisplayString(_ctx.$store.state.currentUser.lastName), 1)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("auth.login")), 1)
        ]))
  ], 64))
}
}

})